<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <div class="flex align-items-center justify-content-between mb-3">
      <h2 class="m-0">Brands</h2>
      <div class="flex gap-2">
        <p-button
          label="New Brand"
          icon="pi pi-plus"
          (onClick)="createBrand()"
          [disabled]="!canCreateBrand"
          pTooltip="{{
            !canCreateBrand
              ? 'You do not have permission to create brands'
              : ''
          }}"
          tooltipPosition="top"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>
      </div>
    </div>

    <div class="mb-4 p-4 border-round-2xl bg-gray-100">
      <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-tag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="brandName" id="brandNameFilter" class="w-full" />
                <label for="brandNameFilter">Brand Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="brandCode" id="brandCodeFilter" class="w-full" />
                <label for="brandCodeFilter">Brand Code</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <app-entity-dropdown-picker
            formControlName="business"
            [adapter]="businessPickerAdapter"
            inputId="businessFilter"
            label="Business"
            placeholder="Any business"
            filterPlaceholder="Filter businesses"
            columnClass="col-12 md:col-6 lg:col-4"
            addonIconClass="pi pi-building"
          ></app-entity-dropdown-picker>

          <app-entity-dropdown-picker
            formControlName="businessUnit"
            [adapter]="businessUnitPickerAdapter"
            inputId="businessUnitFilter"
            label="Business Unit"
            placeholder="Any business unit"
            filterPlaceholder="Filter business units"
            columnClass="col-12 md:col-6 lg:col-4"
            addonIconClass="pi pi-sitemap"
          ></app-entity-dropdown-picker>
        </div>

        <div class="flex justify-content-end gap-2 mt-4">
          <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button" (onClick)="onReset()"></p-button>
          <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
        </div>
      </form>
    </div>

    <p-table
      #dt
      [value]="brands"
      [rows]="10"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [lazy]="true"
      (onLazyLoad)="loadBrands($event)"
      dataKey="id"
      styleClass="p-datatable-striped md-data-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="brandName">
            Brand Name <p-sortIcon field="brandName"></p-sortIcon>
          </th>
          <th pSortableColumn="brandCode">
            Brand Code <p-sortIcon field="brandCode"></p-sortIcon>
          </th>
          <th>Business</th>
          <th>Business Unit</th>
          <th style="width: 10rem">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-brand>
        <tr>
          <td>{{ brand.brandName }}</td>
          <td>{{ brand.brandCode ?? null }}</td>
          <td>{{ brand.businessObject?.businessName ?? brand.businessId ?? '-' }}</td>
          <td>{{ brand.businessUnitObject?.businessUnitName ?? brand.businessUnitId ?? '-' }}</td>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="editBrand(brand.id)"
                [disabled]="!canUpdateBrand"
                pTooltip="{{
                  !canUpdateBrand
                    ? 'You do not have permission to edit brands'
                    : ''
                }}"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteBrand(brand.id)"
                [disabled]="!canDeleteBrand"
                pTooltip="{{
                  !canDeleteBrand
                    ? 'You do not have permission to delete brands'
                    : ''
                }}"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">No Brands found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
